export default __webpack_public_path__ + "static/media/people3.b7aaccd7.jpeg";